import clsx from 'clsx';

export const styles = {
  label: 'tw-block tw-text-sm tw-font-semibold tw-text-neutral-700 tw-mb-2',

  requiredIndicator: 'tw-text-danger-500 tw-ml-0.5',

  base: clsx(
    'tw-w-full tw-rounded-md tw-border tw-bg-neutral-50 tw-text-neutral-900',
    'tw-text-sm tw-appearance-none tw-cursor-pointer',
    'tw-transition-all tw-duration-200 tw-ease-in-out'
  ),

  focus: clsx(
    'focus:tw-outline-none focus:tw-bg-white',
    'focus:tw-border-primary-500 focus:tw-ring-2 focus:tw-ring-primary-100'
  ),

  error: clsx(
    'tw-border-danger-400 tw-bg-danger-50',
    'focus:tw-border-danger-500 focus:tw-ring-danger-100'
  ),

  defaultBorder: clsx(
    'tw-border-neutral-200',
    'hover:tw-border-neutral-300 hover:tw-bg-white'
  ),

  disabled: clsx(
    'tw-bg-neutral-100 tw-text-neutral-500 tw-cursor-not-allowed',
    'tw-border-neutral-200'
  ),

  padding: 'tw-px-4 tw-py-3 tw-pr-11',

  errorMessage: 'tw-mt-2 tw-text-sm tw-text-danger-600',

  hint: 'tw-mt-2 tw-text-sm tw-text-neutral-500',

  iconContainer: clsx(
    'tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0',
    'tw-flex tw-items-center tw-pr-4'
  ),

  chevron: 'tw-h-4 tw-w-4 tw-text-neutral-500',
};
